import { Mutation, Action } from 'vuex-module-decorators';
import { InjectModule, InjectVuexModule } from 'vue-di/vuex';
import { Resolve } from 'vue-di';
import localForage from 'localforage';
// import { Theme } from 'vuetify/types/services/theme'
import { OnClear } from '~/services/clearModule';
import { Settings } from '~/services/settings';

@InjectModule({ stateFactory: true }, module)
export default class LayoutModule extends InjectVuexModule {
    @Resolve
    public settings!: Settings;

    defaultdrawerNavigation = [
        {
            title: 'Eligibility',
            route: '/patient/eligibility',
            enable: true,
        },
        {
            title: 'Patient Consent',
            route: '/patient/patient-authorization',
            enable: true,
        },
        {
            title: 'Patient Information',
            route: '/patient/patient-information',
            enable: false,
        }
    ];

    drawerNavigation = this.defaultdrawerNavigation;

    // Method that gathers all DOM nodes, searches for the current programName
    // and replaces it with the new programName
    // @Action({ rawError: true })

    public drawer = true;
    public showTestPdf = false;

    @Mutation
    public setDrawer(drawer: boolean): void {
        this.drawer = drawer;
    }

    @Mutation
    public toggleDrawer(): void {
        this.drawer = !this.drawer;
    }

    @Mutation
    public setShowTestPDF(showTestPdf: boolean): void {
        this.showTestPdf = showTestPdf;
    }
}
